import React, { Component } from "react";
import NavBar from "../../Components/NavBar/NavBar";
import AuthCheck from "../../Components/Utils/AuthCheck";
import Loader from "react-loader-spinner";
import PageRoute from "../../Components/Utils/PageRoutes";
import "./Users.css";
import { apiUrl } from "../../Components/Utils/Constants";

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      loading: true,
      searchField: "",
    };
  }

  componentDidMount() {
    AuthCheck(this.props);
    this.getUsers();
  }

  getUsers = () => {
    console.log("Get Users");
    fetch(`${apiUrl}/admin/getusers`)
      .then((response) => response.json())
      .then((response) => {
        this.setState({
          users: response,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
      });
  };

  onSearchChange = (event) => {
    console.log(event.target.value);
    this.setState({
      searchField: event.target.value,
    });
  };

  viewUser = (user) => {
    const route = PageRoute.users + "/" + user.id;
    // this.props.history.push(route);
    this.props.history.push({
      pathname: route,
      state: {
        user,
      },
    });
  };

  render() {
    document.title = "Xtendliving | Admin | Users";
    const { loading, users, searchField } = this.state;

    const filteredUsers = users.filter((user) => {
      var firstname = user.firstname
        .toLowerCase()
        .includes(searchField.toLowerCase());
      var lastname = user.lastname
        .toLowerCase()
        .includes(searchField.toLowerCase());
      return firstname || lastname;
    });

    const tableRow = filteredUsers.length ? (
      filteredUsers.map((user, index) => {
        return (
          <tr
            className="showMouse"
            key={index + 1}
            onClick={() => {
              this.viewUser(user);
            }}
          >
            <td>{index + 1}</td>
            <td>{user.firstname}</td>
            <td>{user.lastname}</td>
            <td>{user.phonenumber}</td>
            <td>{user.dob}</td>
            <td>{user.gender}</td>
          </tr>
        );
      })
    ) : (
      <tr className="center" colSpan="6">
        No User Found
      </tr>
    );

    const table = (
      <table className="responsive-table highlight">
        <thead>
          <tr>
            <th>S/N</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Phone Number</th>
            <th>D.O.B</th>
            <th>Gender</th>
          </tr>
        </thead>

        <tbody>{tableRow}</tbody>
      </table>
    );

    return (
      <div>
        <NavBar loggedIn={true} />
        <div className="container center" style={{ marginBottom: 50 }}>
          <h4>Users</h4>
          <div className="center">
            <div className="row">
              <form className="col s12">
                <div className="row">
                  <div className="input-field col s6">
                    <input
                      id="input_text"
                      type="text"
                      data-length="10"
                      onInput={this.onSearchChange}
                    />
                    <label htmlFor="input_text">Search for user by name</label>
                  </div>
                </div>
              </form>
            </div>
          </div>

          {loading ? (
            <Loader type="ThreeDots" color="#000000" height={50} width={50} />
          ) : (
            table
          )}
        </div>
      </div>
    );
  }
}

export default Users;
